import PDFButtonBase from '@/components/PDFButton/Base.vue';
import api from '@/api';

export default {
  mixins: [
    PDFButtonBase,
  ],
  props: {
    clientId: Number,
    businessId: Number,
  },
  methods: {
    fetchPDF() {
      if (this.businessId) {
        return api.resource.rafSlipsForBusiness(this.businessId);
      }
      return api.resource.rafSlips(this.clientId);
    },
  },
};
